module.exports = __webpack_public_path__ + "img/backArrow-blue.c2edc421.svg";